import Vue from 'vue';
import productUnCodeTransformer from './../../transformers/productUnCode';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const products = productUnCodeTransformer.fetchCollection(data.data);
  resolve(products);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('products/search/un_codes', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productUNCode/search.js